import {externalTestSvg as Icon__small__externalTestSvg} from '../Icon__small/Icon__small--externalTest.js'

export var externalTest = {
  name: 'externalTest',
  category: 'icon',
  colorable: true,
  svg: Icon__small__externalTestSvg,
};
